<template>
  <div class="animated fadeIn invoices">
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <!-- newInvoiceModal -->
    <!-- <v-dialog v-model="newInvoiceModal" persistent width="500">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey">انتخاب نوع فروش</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newInvoiceModal = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div>
          <h5 class="c-grey ms-7">نوع فروش خود را انتخاب کنید:</h5>
          <v-card-text class="custom-input mb-9 mt-5">
            <v-row>
              <v-col class="text-center">
                <v-btn
                  class="green-mainBtn py-5"
                  width="150"
                  :to="'/shop/newproforma/wholesale'"
                  >پیش فاکتور فروش عمده</v-btn
                >
              </v-col>
              <v-col class="text-center">
                <v-btn
                  class="purple-mainBtn py-5"
                  width="150"
                  :to="'/shop/newproforma/retail'"
                  >پیش فاکتور فروش خرده</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>

    <!-- retun-dialog -->
    <v-dialog v-model="returnDialog" width="970">
      <v-card class="dash-modal-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">مرجوع کردن اقلام</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="returnDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div class="text-center pb-12" v-if="returnLoading">
          <cube></cube>
          <span style="font-size: 16px">در حال بارگذاری ...</span>
        </div>
        <div v-else>
          <v-card-text>
            <div class="custom-table mt-3">
              <b-table
                responsive
                show-empty
                :current-page="currentPage"
                :per-page="perPage"
                :items="invoicesList"
                :fields="invoiceFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-icon class="red--text text--lightem-1 me-2"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="red--text font-weight-bold text--lightem-1"
                      >هنوز کالایی به فاکتور اضافه نشده است</span
                    >
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:head(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      min-width: 300px;
                    "
                  >
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(price)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() }}
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      (
                        Number(data.item.amount) * data.item.price
                      ).toLocaleString()
                    }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-btn
                      :disabled="data.item.status == 'مرجوع شده'"
                      @click="returnProduct(data.item)"
                      class="purple-mainBtn"
                      width="120"
                      >مرجوع کردن</v-btn
                    >
                  </div>
                </template>
              </b-table>
              <v-row class="mt-6" v-if="invoicesList.length">
                <v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        attach
                        class="shop-select"
                        :menu-props="{ bottom: true, offsetY: true }"
                        outlined
                        v-model="perPage"
                        :items="perPageOptions"
                        @change="currentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                </v-col>
                <v-col>
                  <div>
                    <v-pagination
                      v-model="currentPage"
                      :length="Math.ceil(invoicesList.length / perPage)"
                      :total-visible="5"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      class="float-end"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <div class="text-left py-3 ps-4 pe-4">
            <v-btn
              class="red-mainBtn white--text ms-2 me-2"
              @click="returnDialog = false"
              width="100"
            >
              لغو
            </v-btn>
            <v-btn
              @click="openDeleteDialog()"
              :disabled="checkReturnedItems()"
              class="purple-mainBtn white--text"
              width="120"
            >
              مرجوع کل فاکتور
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- delete-dialog -->
    <v-dialog v-model="deleteDialog" width="600">
      <v-card class="modal-card">
        <h5 class="dark-grey-color py-5">
          <v-icon color="error">$Alert</v-icon>
          <span class="ps-2 pe-2 pt-1"
            >آیا از منقضی کردن پیش‌فاکتور {{ deletedItem.invoiceCode }} اطمینان
            دارید؟</span
          >
        </h5>
        <div class="text-left mt-9">
          <v-btn class="purple-mainBtn" width="90" @click="expire()">بله</v-btn>
          <v-btn
            class="red-borderedBtn ms-2"
            @click="deleteDialog = false"
            width="90"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="convertModal" width="700">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col cols="10">
              <h4 class="c-grey mb-0">
                تبدیل پیش فاکتور {{ selected.invoiceCode }} به فروش
              </h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="convertModal = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <h5 class="mb-4">نوع فروش را انتخاب کنید:</h5>
          <v-row>
            <v-col cols="12">
              <v-select
                label="نوع فروش"
                :items="sellingTypes"
                v-model="convert.sellingType"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" v-if="convert.sellingType == 'definite'">
              <v-select
                label="نوع پرداخت"
                @change="cheque = {}"
                :items="paymentTypes"
                v-model="convert.paymentType"
                outlined
                dense
            /></v-col>
          </v-row>
          <div
            v-if="convert.paymentType == 'cheque'"
            class="pa-5 pt-10 my-6"
            style="
              border: 1px solid #ccc;
              border-radius: 15px;
              position: relative;
            "
          >
            <p
              class="ps-4 pe-4"
              style="position: absolute; top: -9px; background-color: #fff"
            >
              اطلاعات چک را وارد کنید:
            </p>
            <v-row>
              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  type="number"
                  label="* شماره چک"
                  v-model="cheque.number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  label="* نام بانک"
                  v-model="cheque.bankName"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0" sm="6" cols="12">
                <span id="chequeDate">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-edit"
                    v-model="cheque.date"
                    label="* تاریخ چک"
                    :editable="true"
                    class="mt-2"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="cheque.date"
                  element="chequeDate"
                  color="#9c7fb7"
                />
              </v-col>
              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  type="number"
                  label="شماره صیاد"
                  v-model="cheque.chequeSayyad"
                  outlined
                  dense
                  class="mt-2"
                ></v-text-field>
              </v-col>
            </v-row>
            <div v-if="computedchequeInfo" class="d-flex flex-row mt-2">
              <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
              <span class="red--text"
                >وارد کردن شماره چک، نام بانک و تاریخ چک الزامی است.</span
              >
            </div>
          </div>
          <div
            v-if="convert.paymentType == 'cardTransfer'"
            class="pa-5 pt-8 my-6"
            style="
              border: 1px solid #ccc;
              border-radius: 15px;
              position: relative;
            "
          >
            <p
              class="ps-4 pe-4"
              style="position: absolute; top: -9px; background-color: #fff"
            >
              اطلاعات کارت‌ها:
            </p>
            <v-row>
              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  label="* شماره کارت فرستنده"
                  v-model="buyerCardNumber"
                  outlined
                  dense
                  data-maxlength="16"
                  oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                ></v-text-field>
              </v-col>

              <v-col class="py-0" sm="6" cols="12">
                <v-text-field
                  label="* شماره کارت گیرنده"
                  v-model="recipientCardNumber"
                  outlined
                  dense
                  data-maxlength="16"
                  oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col>
              <v-textarea
                outlined
                dense
                label="توضیحات"
                v-model="selected.desc"
              ></v-textarea
            ></v-col>
          </v-row>

          <div class="text-left mt-3">
            <v-btn
              class="red-borderedBtn ms-2 me-2"
              @click="
                convertModal = false;
                selected.desc = '';
              "
              width="90"
              >لغو</v-btn
            >
            <v-btn
              class="purple-mainBtn"
              :loading="busy"
              @click="submit"
              width="90"
              :disabled="computedBtn"
              >ثبت</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <!-- <loading v-if="vLoading" /> -->

    <v-col lg="12" class="me-auto"></v-col>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">پیش‌فاکتور</h4>
      </div>
      <hr class="mt-5" />
      <v-card class="text-center pb-12" v-if="isBusy">
        <cube></cube>
        <span style="font-size: 16px">در حال بارگذاری ...</span>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col cols="12" md="6" class="d-flex flex-row">
              <h4 class="c-purple">پیش‌فاکتور فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4"
                >({{ computedInvoices.length }} فاکتور)</span
              >
            </v-col>
            <v-col class="text-left">
              <v-btn
                to="/shop/newproforma"
                class="purple-borderedBtn"
                height="43"
                style="text-decoration: none"
              >
                <v-icon class="me-1">$Bag</v-icon>افزودن پیش‌فاکتور جدید
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col class="c-grey d-flex flex-row flex-wrap">
              <div class="custom-input d-flex flex-row flex-wrap">
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="$Search"
                  hide-details
                  label="جستجو در کد پیش‌فاکتور..."
                  color="#4ba0e7"
                  @input="currentPage = 1"
                  v-model="codeFilter"
                  class="me-3 mt-2"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="codeFilter.length"
                      class="red--text text--lighten-2 mt-1"
                      @click="
                        codeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="$Search"
                  hide-details
                  label="جستجو در نام مشتری..."
                  color="#4ba0e7"
                  v-model="nameFilter"
                  @input="currentPage = 1"
                  class="me-3 mt-2"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="nameFilter.length"
                      class="red--text text--lighten-2 mt-1"
                      @click="
                        nameFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
              <div class="customSelect2 me-3 pb-0 mt-2">
                <span class="c-blue pt-3 pe-2"> فیلتر وضعیت </span>
                <v-select
                  attach
                  class="shop-select"
                  :menu-props="{ bottom: true, offsetY: true }"
                  dense
                  outlined
                  hide-details
                  :items="types"
                  v-model="typeFilter"
                  @change="currentPage = 1"
                >
                  <template v-slot:append>
                    <v-icon class="c-blue">$ArrowDown</v-icon>
                  </template>
                </v-select>
              </div>
              <MyCalendar
                @submit="searchInvoices()"
                @getStartDate="getStartDate"
                @getEndDate="getEndDate"
                :label="'فیلتر زمانی'"
                :icon="'arrow'"
                :start="startDate"
                :end="endDate"
                class="mt-2"
              />
            </v-col>
          </v-row>
          <hr class="mt-5" />
          <vue-excel-xlsx
            :data="computedInvoices"
            :columns="excelFields"
            class="darkGreen-mainBtn mb-4 float-start"
            style="width: 135px; height: 35px"
            file-name="پیش‌فاکتور  فروشگاه"
            sheet-name=" پیش‌فاکتور فروشگاه"
            :class="computedInvoices.length ? 'white--text' : 'disabled-excel'"
          >
            <v-icon
              :class="computedInvoices.length ? 'white--text' : ''"
              class="me-1"
              >mdi-file-excel-outline</v-icon
            >
            خروجی اکسل
          </vue-excel-xlsx>
          <v-btn
            :disabled="!computedInvoices.length"
            class="darkRed-mainBtn white--text float-end"
            style="width: 135px; height: 35px"
            @click="printReceipt()"
            depressed
            ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
          >
          <div class="custom-table">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedInvoices"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(totalCost)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() + " ریال " }}
                </div>
              </template>
              <template v-slot:cell(shopCustomerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    target="_blank"
                    :href="'/shop/customer/' + data.item.shopCustomerId"
                    >{{ data.value }}</a
                  >
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="purple-mainBtn"
                    width="120"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <!--<v-btn
                    class="green-mainBtn ms-1 mb-1"
                    width="135"
                    height="40"
                    :to="'/shop/invoice/' + row.item.id"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده</v-btn
                  >-->
                  <v-btn
                    class="green-mainBtn ms-1 me-1"
                    width="135"
                    height="40"
                    :to="'/shop/invoice/' + row.item.id"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده</v-btn
                  >
                  <v-btn
                    v-if="row.item.status != 'منقضی شده'"
                    class="lime-mainBtn ms-1 me-1"
                    width="135"
                    height="40"
                    :to="'/shop/editinvoice/' + row.item.id"
                    ><v-icon class="me-1">mdi-pencil</v-icon>ویرایش
                  </v-btn>
                  <v-btn
                    class="purple-mainBtn ms-1 me-1"
                    width="135"
                    height="40"
                    @click="printPreInvoice(row.item)"
                  >
                    <v-icon class="me-1">mdi-printer</v-icon>
                    چاپ رسید
                  </v-btn>
                  <v-btn
                    v-if="row.item.status != 'منقضی شده'"
                    width="135"
                    height="40"
                    class="darkGreen-mainBtn ms-1 me-1 white--text"
                    @click="openConvertModal(row.item)"
                    elevation="0"
                  >
                    <v-icon class="me-1">mdi-refresh</v-icon>
                    تبدیل به فروش
                  </v-btn>
                  <v-btn
                    v-if="row.item.status != 'منقضی شده'"
                    width="135"
                    height="40"
                    class="red-mainBtn ms-1 me-1 white--text"
                    @click="
                      deleteDialog = true;
                      deletedItem = row.item;
                    "
                  >
                    <v-icon class="me-1">mdi-logout-variant</v-icon>

                    منقضی کردن
                  </v-btn>
                </div>
              </template>
            </b-table>
            <v-row class="mt-6" v-if="computedInvoices.length">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      attach
                      class="shop-select"
                      :menu-props="{ bottom: true, offsetY: true }"
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedInvoices.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>

    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">پیش‌فاکتور‌های فروشگاه</h3>
      <b-table :items="computedInvoices" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(totalCost)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ Number(data.value).toLocaleString() + " ریال " }}
          </div>
        </template>

        <template v-slot:cell(type)="data">
          <div style="text-align: center; vertical-align: middle">
            <div
              class="mx-auto"
              :class="data.value == 'حقیقی' ? 'purple-badge' : 'green-badge'"
            >
              {{ data.value }}
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import router from "../../router";
import moment from "moment-jalaali";
// import VueBarcode from "vue-barcode";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    // barcode: VueBarcode,
    MyCalendar,
  },

  data: function () {
    return {
      type: "reprint",
      isLoaded: false,
      info: [],
      // loading: false,
      guide: false,
      types: ["همه", "ثبت شده", "منقضی شده"],
      moment: moment,
      gettingReceipt: true,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد پیش‌فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد پیش‌فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
      ],
      excelFields: [
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "invoiceCode", label: "کد پیش‌فاکتور" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "totalCost", label: "مبلغ (ریال)" },
        { field: "status", label: "وضعیت" },
      ],
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      invoiceType: "proforma",
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      invoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (ریال)" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      invoicesList: [],
      TotalRows: "",
      codeFilter: "",
      nameFilter: "",
      typeFilter: "همه",
      returnDialog: false,
      deleteDialog: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      T: 1,
      striped: true,
      isBusy: false,
      busy: false,
      filter: null,
      invoices: [],
      selected: "",
      newInvoice: {
        customerBalance: "",
        newCustomerBalance: "",
      },
      customer: {},
      printInvoice: {},
      returnModal: false,
      paymentType: "",
      selectedId: "",
      userId: "",
      returnedItems: "",
      returnLoading: false,
      convertModal: false,
      cheque: {},
      convert: {},
      convertModal: false,
      sellingTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      buyerCardNumber: "",
      recipientCardNumber: "",
      deletedItem: {},
      // newInvoiceModal: false,
    };
  },

  methods: {
    // openNewInvoiceModal() {
    //   this.newInvoiceModal = true;
    // },
    openConvertModal(item) {
      this.convert = {};
      this.cheque = {};
      this.convertModal = true;
      this.selected = item;
    },
    submit() {
      let current = moment(new Date()).format("jYYYY/jMM/jDD");
      if (this.selected.expirationDate < current) {
        this.toast("پیش فاکتور معتبر نمی باشد", "error");
      } else {
        this.busy = true;
        Axios.post(
          this.baseUrl + "/ppkpms/shop/sales/convertProforma",
          {
            shopInvoiceId: this.selected.id,
            type: this.convert.sellingType,
            paymentType: this.convert.paymentType,
            chequeNo:
              this.convert.paymentType == "cheque"
                ? this.cheque.number
                  ? this.cheque.number
                  : ""
                : undefined,
            chequeDate:
              this.convert.paymentType == "cheque"
                ? this.cheque.date
                  ? this.cheque.date
                  : ""
                : undefined,
            chequeSayyad:
              this.convert.paymentType == "cheque"
                ? this.cheque.chequeSayyad
                  ? this.cheque.chequeSayyad
                  : ""
                : undefined,
            chequeBank:
              this.convert.paymentType == "cheque"
                ? this.cheque.bankName
                  ? this.cheque.bankName
                  : ""
                : undefined,
            buyerCardNumber:
              this.convert.paymentType == "cardTransfer"
                ? this.buyerCardNumber
                  ? this.buyerCardNumber
                  : ""
                : undefined,
            recipientCardNumber:
              this.convert.paymentType == "cardTransfer"
                ? this.recipientCardNumber
                  ? this.recipientCardNumber
                  : ""
                : undefined,
            description: this.selected.desc ? this.selected.desc : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.busy = false;
            if (res.status == 201) {
              this.toast(res.data, "success");
              this.convertModal = false;
              this.searchInvoices();
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .then(() => {
            //this.print(this.selected, "convertReceipt");
          })
          .catch((err) => {
            this.busy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    getEndDate(value) {
      this.endDate = value;
    },
    searchInvoices() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/invoices",
        {
          type: this.invoiceType,
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.invoices = res.data;
            this.TotalRows = this.invoices.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          console.log(err.response);
          this.isBusy = false;
        });
    },
    computedFilterDate() {
      let date =
        "از تاریخ " +
        this.startDate.split("/")[2] +
        "/" +
        this.persianMonthName(this.startDate.split("/")[1]) +
        "/" +
        this.startDate.split("/")[0] +
        " تا تاریخ " +
        this.endDate.split("/")[2] +
        "/" +
        this.persianMonthName(this.endDate.split("/")[1]) +
        "/" +
        this.endDate.split("/")[0];

      return date;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    openReturnDialog(item) {
      this.returnDialog = true;
      this.selected = item;
      this.selectedId = item.id;
      this.getReturnInfo();
    },
    getReturnInfo() {
      this.returnLoading = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + this.selectedId,
        // {
        //   shopCustomerId: this.selected.id,
        // },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.returnLoading = false;
          if (res.status == 200) {
            this.userId = res.data.shopCustomerId;
            this.invoicesList = res.data.details;
            this.returnedItems = res.data.returnedItems
              ? res.data.returnedItems
              : [];
            this.checkReturnItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.returnLoading = false;
        });
    },
    checkReturnItems() {
      this.invoicesList.forEach((item) => {
        if (this.returnedItems.indexOf(item.id) != -1) {
          item.status = "مرجوع شده";
        } else {
          item.status = "ثبت شده";
        }
      });
      this.checkReturnedItems();
    },
    returnProduct(item) {
      this.busy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/partialReturn/" + this.selectedId,
        {
          shopCustomerId: this.userId,
          details: item,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.returnDialog = false;
            this.searchInvoices();
            this.getReturnInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    openDeleteDialog() {
      this.deleteDialog = true;
    },
    expire() {
      this.expireBusy = true;
      Axios.patch(
        this.baseUrl +
          "/ppkpms/shop/sales/expireProforma/" +
          this.deletedItem.id,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.expireBusy = false;
          if (res.status == 200) {
            // console.log(res.data);
            this.toast(res.data.message, "success");
            this.deleteDialog = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.expireBusy = false;
          this.toast(err.response.data, "error");
        });
    },
    printPreInvoice(item) {
      this.$router.push("/print/reprint/preinvoice/" + item.id);
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + item.id,
        // {
        //   shopInvoiceId: item.id,
        // },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
            if (this.paymentType == "قطعی") {
              this.newInvoice.newCustomerBalance =
                this.newInvoice.customerBalance;
            } else {
              this.newInvoice.newCustomerBalance =
                this.newInvoice.customerBalance + this.printInvoice.totalCost;
            }
            localStorage.setItem(
              "oldCustomerBalance",
              this.newInvoice.customerBalance
            );
            printReceipt2();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        // .then(() => {
        //   setTimeout(() => {
        //     this.printReceipt();
        //   }, 400);
        // })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      setTimeout(() => {
        myWindow.document.write("</head><body>");
        myWindow.document.write(
          document.getElementById("printTable").innerHTML
        );
        myWindow.document.write("</body></html>");
        myWindow.document.close();
      }, 100);

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    printReceipt2() {
      //printing receipt
      var myWindow = window.open(
        "#",
        "preInvoiceReceipt",
        "height=auto,width=800"
      );
      myWindow.document.write(
        "<html><head><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      setTimeout(() => {
        myWindow.document.write("</head><body>");
        myWindow.document.write(
          document.getElementById("preInvoiceReceipt").innerHTML
        );
        myWindow.document.write("</body></html>");
        myWindow.document.close();
      }, 100);

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkReturnedItems() {
      if (this.returnedItems.length == this.invoicesList.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    computedchequeInfo() {
      if (this.convert.paymentType == "cheque") {
        if (!this.cheque.number || !this.cheque.bankName || !this.cheque.date) {
          return true;
        } else return false;
      } else return false;
    },
    computedBtn() {
      if (this.convert.sellingType) {
        if (this.convert.sellingType == "definite") {
          if (this.convert.paymentType) {
            if (this.convert.paymentType == "cardTransfer") {
              if (!this.recipientCardNumber || !this.buyerCardNumber) {
                return true;
              } else return false;
            } else if (this.convert.paymentType == "cheque") {
              if (
                !this.cheque.number ||
                !this.cheque.bankName ||
                !this.cheque.date
              ) {
                return true;
              } else return false;
            }
          } else return true;
        } else return false;
      } else return true;
    },
    totalCost() {
      return 1000;
    },
    computedInvoices() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.invoices.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      } else {
        filtered = this.invoices.filter(
          (x) =>
            x.status == this.typeFilter &&
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      }
      return filtered;
    },
  },

  mounted() {
    this.searchInvoices();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
.v-menu__content {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  margin-top: 10px;
}
.invoices {
  .custom-input {
    .v-input__slot {
      width: 210px !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #4ba0e7 !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
  .customSelect2 {
    padding-bottom: 10px;
    .v-input__slot {
      width: 120px !important;
    }
    .v-select__selection--comma {
      font-size: 14px !important;
    }
  }
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}
@media print {
  td {
    font-family: "iransans" !important;
    border-radius: 3px;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
